const EXCLUDED_ROUTES = [
  "/login",
  "/verifyemail",
  "/verifyemaillink",
  "/verifynewemail",
  "/resetpassword",
  "/joingroup",
  "/creategroup",
  "/device/claim",
  "/subscription/confirm",
  "/group/transfer",
  "/404",
  "/termsandconditions",
];

const EXCLUDED_PATTERNS = [
  /\/group\/.*\/invite/, // Group invite pages
  /\/group\/.*\/editinvite/, // Edit invite pages
  /\/device\/claim/, // Device claim pages
  /\/subscription\/confirm/, // Subscription confirmation
  /\/group\/transfer/, // Group transfer
];

const SKIP_RESTORE_KEY = "skipRestoreFrom404";

export function setSkipRestoreFrom404(): void {
  sessionStorage.setItem(SKIP_RESTORE_KEY, "true");
}

export function hasSkipRestoreFrom404Flag(): boolean {
  return sessionStorage.getItem(SKIP_RESTORE_KEY) === "true";
}

export function clearSkipRestoreFrom404(): void {
  sessionStorage.removeItem(SKIP_RESTORE_KEY);
}

export function shouldSaveRoute(pathname: string): boolean {
  if (pathname === "/" || pathname === "") {
    return false;
  }

  if (EXCLUDED_ROUTES.includes(pathname)) {
    return false;
  }

  for (const pattern of EXCLUDED_PATTERNS) {
    if (pattern.test(pathname)) {
      return false;
    }
  }

  return true;
}

export function getPostLoginRedirect(): string {
  const redirectURL = localStorage.getItem("redirectURL");
  if (redirectURL && redirectURL !== "/") {
    const pathname = redirectURL.split("?")[0];
    if (pathname && pathname !== "/") return redirectURL;
    clearRedirectURL();
  }

  const lastVisitedPath = localStorage.getItem("lastVisitedPath");
  if (lastVisitedPath && shouldSaveRoute(lastVisitedPath.split("?")[0])) {
    return lastVisitedPath;
  }
  if (lastVisitedPath) clearLastVisitedPath();
  return "/";
}

export function clearRedirectURL(): void {
  localStorage.removeItem("redirectURL");
}

export function clearLastVisitedPath(): void {
  localStorage.removeItem("lastVisitedPath");
}

export function getBackFrom404Path(): string {
  const last = localStorage.getItem("lastVisitedPath");
  if (!last) return "/";
  const pathname = last.split("?")[0];
  if (!pathname || pathname === "/" || pathname === "/404") return "/";
  if (!shouldSaveRoute(pathname)) return "/";
  return last;
}
